import { Button } from 'components';
import {
  handleSave,
  outcomes,
  handleSubmitDisabled,
  handleThirdPartyValidations,
  isBeneficiary,
  isAuditor,
} from 'utils';
import { ReactComponent as Check } from 'assets/icons/check.svg';
import { ReactComponent as SaveIcon } from 'assets/icons/save_icon.svg';
import { submitFinalTask, thirdPartyValidations } from 'store/forms/actions';
import { getLocalString, localNames } from 'utils/localisation.service';
import locale from 'antd/lib/date-picker/locale/el_GR';
import { validAFM } from 'utils';
import { isNil } from 'lodash';
import { updateFormField } from 'store/forms/actions';
import { isExpiredDate } from 'utils/helpers';

export const renderButtons = ({
  task,
  state,
  dispatch,
  saveTask,
  taskId,
  formId,
  setIsVisible,
  setOutcome,
  user,
  viewMode,
  activeFormId = null,
  applStatus,
  setVisibleBanner,
  setInvalidModalVisible,
  locales,
}) => {
  const formKey = task.formKey;
  const isSaved = state?.carrier?.rejectReasons?.isSubmitValid ? true : false;
  const isUserKTP =
    user.groups?.filter(a => a.id.startsWith('KTP')).length > 0
      ? user.groups?.filter(a => a.id.startsWith('KTP')).length > 0
      : false;
  const isUserProvider =
    user.groups?.filter(a => a.id.startsWith('ProviderResourceGroup')).length >
    0
      ? user.groups?.filter(a => a.id.startsWith('ProviderResourceGroup'))
          .length > 0
      : false;
  // console.log("process.env.REACT_APP_SUBMIT:",process.env.REACT_APP_SUBMIT);
  const isInAuditApplication =
    state.activeTaskName === 'task.name.audit_application';
  const isSaveMode =
    !viewMode || (isInAuditApplication && isBeneficiary(user?.groups));

  return (
    <div className="app-layout__buttons">
      {isSaveMode &&
        (isBeneficiary(user?.groups) || isAuditor(user?.groups)) && (
          // user.privileges?.includes("CanRenderSaveBtn") &&
          <Button
            type="default"
            id="save"
            className="saveButton"
            label={getLocalString(locales, localNames.REQUEST_PAGE_SAVEBUTTON)}
            disabled={!isSaved}
            onClick={() =>
              handleSave({
                state,
                dispatch,
                saveTask,
                taskId,
                formId,
                isSaved,
                activeFormId,
              })
            }
          />
        )}
      {!viewMode && isBeneficiary(user?.groups) && (
        // user.privileges?.includes("CanRenderSubmitBtn") &&
        <Button
          type="default"
          className={'ant-btn-primary cancelButton'}
          label={'Ακύρωση'}
          disabled={false}
          onClick={() => {
            setOutcome(outcomes.cancelBeneficiary);
            setIsVisible(true);
          }}
        />
      )}

      {!viewMode && isBeneficiary(user?.groups) && (
        // user.privileges?.includes("CanRenderSubmitBtn") &&
        <Button
          type="default"
          className={'ant-btn-primary submit-btn'}
          label={getLocalString(
            locales,
            localNames.REQUEST_PAGE_SUBMISSIONBUTTON
          )}
          disabled={handleSubmitDisabled({
            user: { ...user },
            state: { ...state },
            formKey,
          })}
          onClick={() => {
            setOutcome(isBeneficiary(user?.groups) ? outcomes.submitNP : '');
            setIsVisible(true);
          }}
        />
      )}
      {!viewMode && isAuditor(user?.groups) && (
        // user.privileges?.includes("CanRenderSubmitBtn") &&
        <Button
          type="default"
          className={'ant-btn-primary submit-btn'}
          // label={getLocalString(locales,localNames.REQUEST_PAGE_SUBMISSIONBUTTON)}
          label={'Έγκριση'}
          disabled={handleSubmitDisabled({
            user: { ...user },
            state: { ...state },
            formKey,
          })}
          onClick={() => {
            setOutcome(isAuditor(user?.groups) ? outcomes.submitNP : '');
            setIsVisible(true);
          }}
        />
      )}
      {!viewMode && isUserKTP && (
        <Button
          type="default"
          className={'ant-btn-primary reject-btn'}
          label={getLocalString(
            locales,
            localNames.REQUEST_PAGE_OUTLINE_REJECT
          )}
          // disabled={
          //   handleSubmitDisabled({
          //   user: { ...user},
          //   state: { ...state },
          //   formKey,
          // })}
          disabled={viewMode}
          //   icon={
          //     <Check width={15} height={15} className={'mr-1'} />
          // }
          onClick={() => {
            setOutcome(outcomes.rejectKtp);
            setIsVisible(true);
          }}
        />
      )}
      {!viewMode && isUserKTP && (
        <Button
          type="default"
          className={'ant-btn-primary submit-btn'}
          label={getLocalString(
            locales,
            localNames.REQUEST_PAGE_OUTLINE_APPROVE
          )}
          // disabled={
          //   handleSubmitDisabled({
          //   user: { ...user},
          //   state: { ...state },
          //   formKey,
          // })}
          disabled={viewMode}
          //   icon={
          //     <Check width={15} height={15} className={'mr-1'} />
          // }
          onClick={() => {
            setOutcome(outcomes.approveKtp);
            setIsVisible(true);
          }}
        />
      )}
    </div>
  );
};
